import {
  DepartmentEnum,
  PayslipCategoryEnum,
  PayslipOwnerEnum,
  PayslipTypeEnum,
} from 'features/Enterprise/Payroll/types'

const PAYROLL_TYPE_TO_API: Record<string, string> = {
  [PayslipTypeEnum.REGULAR]: 'Regular',
  [PayslipTypeEnum.INCENTIVE]: 'Incentive',
  [PayslipTypeEnum.PPD]: 'PPD',
}

export const toPayrollTypeApi = (payrollType: string): string =>
  PAYROLL_TYPE_TO_API[payrollType] ?? payrollType

export const parsePayoutTypeFromValidateDetail = (raw: string | undefined): PayslipTypeEnum => {
  const normalized = raw?.trim().toLowerCase() ?? ''
  switch (normalized) {
    case 'incentive':
      return PayslipTypeEnum.INCENTIVE
    case 'regular':
    default:
      return PayslipTypeEnum.REGULAR
  }
}

export const mapOwnerToDepartment = (owner: string): DepartmentEnum =>
  owner === PayslipOwnerEnum.PEOPLE ? DepartmentEnum.HR : DepartmentEnum.OPS

export const PAYSLIP_CATEGORY_API_TO_UI_MAP: Record<string, string> = {
  [PayslipCategoryEnum.INCOME]: 'Pendapatan Lainnya',
  Incentive: 'Incentive',
  [PayslipCategoryEnum.INCENTIVE]: 'Incentive',
  [PayslipCategoryEnum.DEDUCTION]: PayslipCategoryEnum.DEDUCTION,
}

export const getPayslipCategoryLabel = (category: string): string =>
  PAYSLIP_CATEGORY_API_TO_UI_MAP[category] ?? category

export const isIncomePayslipCategory = (category: string): boolean =>
  ['Pendapatan Lainnya', 'Incentive'].includes(getPayslipCategoryLabel(category))
